export const RECENTLY_VIEWED_LIMIT = 5;

type ViewedFilterableListing = {
  uriMalone?: string;
  uriBuilding?: string;
  uriV2?: string;
};

export const selectRecentlyViewedListings = <T extends ViewedFilterableListing>(
  viewedListings: Array<T> | undefined,
  currentPathname: string,
): Array<T> => {
  if (!viewedListings) return [];
  return viewedListings.slice(0, RECENTLY_VIEWED_LIMIT).filter((listing) => {
    return (
      currentPathname !== listing.uriMalone &&
      currentPathname !== listing.uriBuilding &&
      currentPathname !== listing.uriV2
    );
  });
};
